import Decision from 'slotworks/state-machine/decisions/decision';
import { Exit } from 'slotworks/state-machine/data/exit';
import gameState from 'slotworks/model/game-state';
import WheelBonusRecord from 'integration/records/wheel-bonus-record';
import WheelBonusResult from 'integration/results/wheel-bonus-result';

export default class IsBonusWheel extends Decision {
    public evaluate() {
        const record = gameState.getCurrentGame().latestRecord();

        if(record instanceof WheelBonusRecord && record.beenPaid !== true) {
            return Exit.True;
        } else if(record.getResultsOfType(WheelBonusResult).length > 0) {
            return Exit.True;
        }

        return Exit.False;
    }
}
